import { getRawLocalStorageItem, setRawLocalStorageItem } from 'src/services/storage/local';
import { UIStateStore } from './UIStateStore';

export class LocalStorageUIStateStore implements UIStateStore {
    get(key: string) {
        return getRawLocalStorageItem(key) ?? null;
    }
    put(key: string, value: unknown) {
        setRawLocalStorageItem(key, `${value}`);
    }
}
